import { Inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';

import { SessionService } from '../session/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EnvironmentConfig } from '../interfaces/environment.interface';
import { APP_ENVIRONMENT } from './environment.injection-token';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  public loginRoute = '/account/login';  
  public forbiddenRoute = '/forbidden';
  
  // Prevenir múltiples redirecciones simultáneas al login
  private isRedirectingToLogin = false;

  constructor(
    private session: SessionService,
    private router: Router,
    @Inject(APP_ENVIRONMENT) private environment: EnvironmentConfig
    ) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  return next.handle(req).pipe(
    catchError((event: unknown) => {
      if (event instanceof HttpErrorResponse) {
        if (event.status === 401) {

          
          // Prevenir múltiples redirecciones simultáneas
          if (this.isRedirectingToLogin) {

            return throwError(() => event);
          }
          
          this.isRedirectingToLogin = true;
          
          if (this.session.user) {

            this.session.logout();
          } else {

            void this.router.navigate([this.loginRoute]).then(() => {
              // Resetear flag después de navegar
              setTimeout(() => {
                this.isRedirectingToLogin = false;
              }, 1000);
            });
          }
        } else if (event.status === 403) {

          if (this.session.user) {
            void this.router.navigate([this.forbiddenRoute]);
          } else {
            this.session.logout();
          }
        } else if (event.status === 0) {
          // Error de red - NO redirigir al login

        }
      }
      return throwError(() => event);
    }),
    map((res: HttpEvent<any>): HttpEvent<any> => {
      if (
        res instanceof HttpResponse &&
        res.url?.includes(this.environment.apiBaseUrl) &&
        res.body?.data
      ) {
        return res.clone({ body: res.body.data });
      }
      return res;
    })
  );
}

}
